import { authData } from "./Service";
import { LETTER_CONFIG_ENDPOINT } from "./apiRoutes";

export const getLetterConfigApi = async () => {
  const response = await authData.get(LETTER_CONFIG_ENDPOINT);
  return response?.data;
};

export const updateLetterConfigApi = async (data) => {
  const response = await authData.put(LETTER_CONFIG_ENDPOINT, data);
  return response?.data;
};
